<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="orange-text">Declaraciones de Dueño Beneficiario</h4>

    <div class="row">
      <div class="col-12">
        <b-table hover :fields="fieldsCuadro" :items="constitutiva.accionistas">
          <template #cell(index)="{ index }">
            {{ getIndex(index) }}
          </template>
          <template #cell(nombreCompleto)="{ item }">
            {{ getFullName(item) }}
          </template>
          <template #cell(acciones)="{ index, item }">
            <b-avatar
              :button="!disabledComputed"
              :variant="item.isValid ? 'success' : 'secondary'"
              @click="editBeneficiario(index)"
              size="lg"
            ></b-avatar>
          </template>
        </b-table>
      </div>
    </div>
    <span class="text-warning font-weight-bold">
      <!-- <b-icon icon="exclamation-triangle-fill" class="mr-1"></b-icon> -->
      {{ validMessage }}
    </span>

    <b-row>
      <b-col class="d-flex justify-content-end">
        <!-- <b-button class="btn-fill" @click="">Regresar</b-button> -->
        <b-button class="btn-fill orange-btn" @click="continuarHandler" :disabled="disabledComputed">Continuar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { AccionistasApi, BeneficiariosControladoresApi, ComparecientesApi } from "@/api";

export default {
  name: "BeneficiarioControlador",

  computed: {
    fieldsCuadro() {
      return [
        { key: "index", label: "#", class: "text-center" },
        { key: "nombreCompleto", label: "Nombre", class: "text-center" },
        { key: "persona", label: "Persona", class: "text-center" },
        { key: "acciones", label: "Dueño Beneficiario", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
    },
    disabledComputed() {
      const formulario = this.constitutiva.formularios.find((f) => f.formulario === "BeneficiarioControlador");
      return formulario?.guardado == 1;
    },
  },

  created() {
    this.validateInfo();
    // this.enableSave();
  },

  watch: {
    "constitutiva.accionistas": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
  },

  components: {},

  props: {
    constitutiva: { type: Object },
  },

  data() {
    return {
      loading: false,
      canValidate: false,
      isAllValid: false,
      validMessage: "",
    };
  },

  methods: {
    getIndex(index) {
      return index + 1;
    },

    getFullName(compareciente) {
      let nombreCompleto = compareciente.denominacion_social;

      if (compareciente.persona.includes("Física")) {
        nombreCompleto = `${compareciente.nombre} ${compareciente.paterno} ${compareciente.materno || ""}`.trimEnd();
      }

      return nombreCompleto;
    },

    enableSave() {
      this.canValidate = true;
    },

    editBeneficiario(index) {
      this.$emit("editBeneficiarioControlador", index);
    },

    async validateInfo() {
      try {
        this.loading = true;

        for (const accionista of this.constitutiva.accionistas) {
          const fetchedAccionista = await AccionistasApi.getAccionistaByComparecienteId(accionista.id);

          if (!fetchedAccionista.clausula_lfpiorpi_id) {
            accionista.isValid = false;
            continue;
          }
          if ([2, 3, 4, 5].includes(fetchedAccionista.clausula_lfpiorpi_id)) {
            const { value } = await BeneficiariosControladoresApi.list({
              page: 0,
              registersPerPage: 0,
              accionistaComparecienteId: accionista.id,
            });

            if (value.length === 0) {
              accionista.isValid = false;
              continue;
            }

            let isValidBeneficiario = true;
            for (const beneficiario of value.filter((b) => b.tipo_beneficiario === 1)) {
              const isValid = await ComparecientesApi.validacion({
                comparecientes_id: beneficiario.accionista_compareciente_id,
                tipo: "",
              });

              if (!isValid) {
                isValidBeneficiario = false;
                continue;
              }
            }

            if (!isValidBeneficiario) {
              accionista.isValid = false;
              continue;
            }
          }

          if (!fetchedAccionista.clausula_cff_id) {
            accionista.isValid = false;
            continue;
          }
          if ([2, 4].includes(fetchedAccionista.clausula_cff_id)) {
            const { value } = await BeneficiariosControladoresApi.list({
              page: 0,
              registersPerPage: 0,
              accionistaComparecienteId: accionista.id,
            });

            if (value.length === 0) {
              accionista.isValid = false;
              continue;
            }

            let isValidBeneficiario = true;
            for (const beneficiario of value.filter((b) => b.tipo_beneficiario === 2)) {
              const isValid = await ComparecientesApi.validacion({
                comparecientes_id: beneficiario.accionista_compareciente_id,
                tipo: "",
              });

              if (!isValid) {
                isValidBeneficiario = false;
                continue;
              }
            }

            if (!isValidBeneficiario) {
              accionista.isValid = false;
              continue;
            }
          }

          accionista.isValid = true;
        }

        this.isAllValid = this.constitutiva.accionistas.every((a) => a.isValid);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    continuarHandler() {
      this.validateInfo().then(() => {
        if (!this.isAllValid) {
          this.validMessage = "Información incompleta";
        } else {
          this.validMessage = "";
          this.$emit("continuarEvent");
        }
      });
    },
  },
};
</script>

<style scoped>
.completado_green {
  background-color: yellowgreen !important;
}

.completado_yellow {
  background-color: gold !important;
}
</style>
